import { REST_CHATS } from '../../../../constants';
import { Dispatch, ThunkAction } from '../../../../../types/actions';
import { fetchHandler } from '../../../../../util/fetchHandler';
import { Util } from '../../../../../util/util';
import { getRestHeadersDelete } from '../../../../helpers/getRestHeadersHelper';
import { IRestChat, TChatId } from 'app/types/rest/IRestChat';

//TODO done
export const deleteRest = (
    id: TChatId
): ThunkAction => {
    const action = (
        dispatch: Dispatch
    ) => {
        return fetchHandler<IRestChat>(
            Util.getApiUrl(
                `${REST_CHATS}chat/${id}`),
                getRestHeadersDelete()
        );
    };
    return action;
};
